'use strict'

jQuery(document).ready(function($) {
	$('.mobilesearch__trigger').on('click', function(e) {
		e.preventDefault();

		// Navigation is open but it has been triggered by the navigation menu icon
		if ($('.mobilemenu__trigger').hasClass('mobilemenu__open')) {
			// Change icon to cross on search menu
			$('.mobilesearch__trigger').addClass('mobilesearch__open');
			// Change cross to icon on navigation menu
			$('.mobilemenu__trigger').removeClass('mobilemenu__open');
			// Keep the mobile navigation menu open
			$('.navigation__menu').addClass('navigation__menu--open');
			// Open the search view
			$('.navigation__search--mobile-view').addClass('navigation__search--mobile-view--open');
			// Hide the navigation items
			$('.navigation__menu--list').hide();
			// Hide the social link items
			$('.navigation__socialicons--bottom').hide();

		// Navigation is open and has been triggered by the search menu icon
		} else if ($(this).hasClass('mobilesearch__open')) {
			// Change cross to icon on search menu
			$('.mobilesearch__trigger').removeClass('mobilesearch__open');
			// Change cross to icon on navigation menu
			$('.mobilemenu__trigger').removeClass('mobilemenu__open');
			// Close the mobile navigation menu
			$('.navigation__menu').removeClass('navigation__menu--open');
			// Close the search view
			$('.navigation__search--mobile-view').removeClass('navigation__search--mobile-view--open');
			// Show the navigation items
			$('.navigation__menu--list').show();
			// Show the social link items
			$('.navigation__socialicons--bottom').show();

		// Navigation is closed
		} else {
			// Change icon to cross on search menu
			$('.mobilesearch__trigger').addClass('mobilesearch__open');
			// Change cross to icon on navigation menu
			$('.mobilemenu__trigger').removeClass('mobilemenu__open');
			// Open the mobile navigation menu
			$('.navigation__menu').addClass('navigation__menu--open');
			// Open the search view
			$('.navigation__search--mobile-view').addClass('navigation__search--mobile-view--open');
			// Hide the navigation items
			$('.navigation__menu--list').hide();
			// Hide the social link items
			$('.navigation__socialicons--bottom').hide();
		}
		// Change the nav background to grey
		$('.navigation__menu--list-container').css('background-color', '#E9E9E9');
	});

	$('.mobilemenu__trigger').on('click', function(e) {

		// Navigation is open but it has been triggered by the search menu icon
		if ($('.mobilesearch__trigger').hasClass('mobilesearch__open')) {
			// Change cross to icon on search menu
			$('.mobilesearch__trigger').removeClass('mobilesearch__open');
			// Change icon to cross on navigation menu
			$('.mobilemenu__trigger').addClass('mobilemenu__open');
			// Keep the mobile navigation menu open
			$('.navigation__menu').addClass('navigation__menu--open');
			// Hide the search view
			$('.navigation__search--mobile-view').removeClass('navigation__search--mobile-view--open');
			// Show the navigation items
			$('.navigation__menu--list').show();
			// Show the social link items
			$('.navigation__socialicons--bottom').show();
		}
		// Change the nav background to blue except if we're on a page template that has a white header area.
		if ( ! $('body').hasClass('.archive, .template-page-sidebar-left')) {
			$('.navigation__menu--list-container').css('background-color', '#001337');
		}
	});
});
